import { colors } from '@material-ui/core';
import React from 'react';

export default function IconGraphItem({ icon0, icon1, value, color }) {
  if (value === null) return <span style={{color: colors.grey[400]}}>✕</span>
  value = +value
  const icon = value === 0 ? icon0 : icon1
  const iconWithColor = <icon.type {...icon.props} style={{color: color, fontSize: '2.5rem'}}/>
  return (<>{ iconWithColor }</>)
}